import { render, staticRenderFns } from "./new-project.vue?vue&type=template&id=49519d1d&"
import script from "./new-project.vue?vue&type=script&lang=js&"
export * from "./new-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports